import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '../models';
const selectDomain = (state) => state.addProduct || initialState;

export const selectError = createSelector(
  [selectDomain],
  (addProduct) => addProduct.error
);
